export default "__VITE_ASSET__Bk8o$ORt__"